import * as datasources from "../common_metadata/datasource.js"
import { Serializable, TextProperty, BaseProperty, TranslatableTextProperty, ColumnProperty } from "../property_types.js"


export class FlexcelExportSettings extends Serializable {
    private labelMetadata = new TranslatableTextProperty("label", "Label");
    public label: string;

    private excelTemplateMetadata = new TextProperty("excelTemplateName", "Excel template");
    public excelTemplateName: string;

    public dataSource: datasources.Datasource;

    private selectMetadataAll: BaseProperty[] = [this.labelMetadata, this.excelTemplateMetadata, datasources.dataSourceMetadata];

    getMetadata(): BaseProperty[] {
        return this.selectMetadataAll;
    }
}


export class TableFlexcelExportSettings extends FlexcelExportSettings {
    private keyFieldMetadata = new ColumnProperty("keyField", "Key field", "dataSource");
    public keyField: string;

    private tableFlexcelMetaData: BaseProperty[];

    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.tableFlexcelMetaData = baseMetaData.concat([this.keyFieldMetadata]);
    }

    getMetadata(): BaseProperty[] {
        return this.tableFlexcelMetaData;
    }
}